import * as React from 'react';
import './index.css';

// 默认行高 20
const DynamicTagLineHeight = 20;

interface IDynamicTag {
  tag: IDynamicSubTag;
  extraStyle?: React.CSSProperties;
}

interface IDynamicSubTag {
  text?: string;
  color?: string;
  icon?: string;
  bgColor?: string;
}

export default class DiscountTag extends React.PureComponent<IDynamicTag> {
  render() {
    const { tag } = this.props;
    // maxlines 为 0，自动撑高，maxlines不为0 给最大高度
    return (
      <view
        className="tag-container"
        style={{
          height: DynamicTagLineHeight,
          backgroundColor: tag?.bgColor || '#00000000',
        }}
      >
        {tag.icon && this.renderImageSubTag(tag)}
        {tag.text && this.renderTextSubTag(tag)}
      </view>
    );
  }

  renderTextSubTag = (tag: IDynamicSubTag) => {
    const { extraStyle } = this.props;
    return (
      <text
        className="sub-text-tag"
        style={{
          height: DynamicTagLineHeight,
          color: tag.color || '#00000000',
          ...extraStyle, // 如新人折扣菜tag不需要粗体 额外传入样式
        }}
        content={tag.text}
      />
    );
  }

  renderImageSubTag = (tag: IDynamicSubTag) => (
    <view
      style={{
        height: 12,
        width: 12,
        marginRight: 2,
      }}
    >
      <image
        className="sub-image-tag"
        src={tag.icon}
      />
    </view>
  )
}
